/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRecordEventsResponseFailureFromJSON, StreemApiRecordEventsResponseFailureToJSON, } from './';
export function StreemApiRecordEventsResponseFromJSON(json) {
    return StreemApiRecordEventsResponseFromJSONTyped(json, false);
}
export function StreemApiRecordEventsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'failures': !exists(json, 'failures') ? undefined : (json['failures'].map(StreemApiRecordEventsResponseFailureFromJSON)),
    };
}
export function StreemApiRecordEventsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'failures': value.failures === undefined ? undefined : (value.failures.map(StreemApiRecordEventsResponseFailureToJSON)),
    };
}
//# sourceMappingURL=StreemApiRecordEventsResponse.js.map